var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBobaAvatar4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 335"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4535202"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.4344 40.8153C31.7201 40.8153 40.8689 31.6785 40.8689 20.4077C40.8689 9.13683 31.7201 0 20.4344 0C9.14881 0 0 9.13683 0 20.4077C0 31.6785 9.14881 40.8153 20.4344 40.8153Z",
    fill: "#414143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.33917 23.08C9.5447 23.08 11.3326 21.2944 11.3326 19.0917C11.3326 16.8891 9.5447 15.1035 7.33917 15.1035C5.13365 15.1035 3.3457 16.8891 3.3457 19.0917C3.3457 21.2944 5.13365 23.08 7.33917 23.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.0872 16.619C22.2927 16.619 24.0807 14.8334 24.0807 12.6308C24.0807 10.4282 22.2927 8.64258 20.0872 8.64258C17.8817 8.64258 16.0938 10.4282 16.0938 12.6308C16.0938 14.8334 17.8817 16.619 20.0872 16.619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.5789 18.1708C23.1769 18.1708 24.4723 16.8771 24.4723 15.2812C24.4723 13.6853 23.1769 12.3916 21.5789 12.3916C19.981 12.3916 18.6855 13.6853 18.6855 15.2812C18.6855 16.8771 19.981 18.1708 21.5789 18.1708Z",
    fill: "#414143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.05743 24.9139C10.6554 24.9139 11.9508 23.6202 11.9508 22.0243C11.9508 20.4285 10.6554 19.1348 9.05743 19.1348C7.45947 19.1348 6.16406 20.4285 6.16406 22.0243C6.16406 23.6202 7.45947 24.9139 9.05743 24.9139Z",
    fill: "#414143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M8.93687 26.7802L15.5977 26.5996L13.0057 31.0393H6.16406L8.93687 26.7802Z",
    fill: "#A0A295"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M13.1699 30.3613L13.9083 34.8763",
    stroke: "#A0A295",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M15.4316 26.7031L16.1701 31.2181",
    stroke: "#A0A295",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M6.43359 30.918L7.41311 36.3359",
    stroke: "#A0A295",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M16.1693 30.4687L22.8301 30.2881L20.2381 34.7128H13.3965L16.1693 30.4687Z",
    fill: "#A0A295"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M20.4043 34.0469L21.1427 38.5618",
    stroke: "#A0A295",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M22.6641 30.3916L23.4025 34.8915",
    stroke: "#A0A295",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M13.668 34.5898L14.6626 40.354",
    stroke: "#A0A295",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M24.5184 21.8431L31.1641 21.6475L28.5872 26.0872H21.7305L24.5184 21.8431Z",
    fill: "#A0A295"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M28.7383 25.4268L29.4918 29.9267",
    stroke: "#A0A295",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M30.998 21.7539L31.7364 26.2689",
    stroke: "#A0A295",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M22.002 25.9668L22.7404 30.4818",
    stroke: "#A0A295",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M34.1322 21.122L40.793 20.9414L38.2161 25.3811H31.3594L34.1322 21.122Z",
    fill: "#A0A295"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M38.3672 24.7031L39.1357 28.6161",
    stroke: "#A0A295",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M40.627 21.0449L40.9133 22.6553",
    stroke: "#A0A295",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M31.6309 25.2598L32.3693 29.7597",
    stroke: "#A0A295",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M31.0731 13.9564L37.7187 13.7607L35.1418 18.2005H28.2852L31.0731 13.9564Z",
    fill: "#A0A295"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M35.293 17.5391L36.0465 22.039",
    stroke: "#A0A295",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M37.5527 13.8672L38.8939 20.8955",
    stroke: "#A0A295",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M28.5566 18.082L29.2951 22.597",
    stroke: "#A0A295",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M23.6127 34.1845L30.2735 34.0039L27.6815 38.4286H20.8398L23.6127 34.1845Z",
    fill: "#A0A295"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M27.8496 37.7656L28.1962 39.7823",
    stroke: "#A0A295",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M30.1094 34.1074L31.0135 38.2612",
    stroke: "#A0A295",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M21.1113 38.3252L21.5031 41.2298",
    stroke: "#A0A295",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M29.431 27.2015L36.0918 27.0059L33.4998 31.4456H26.6582L29.431 27.2015Z",
    fill: "#A0A295"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M33.666 30.7842L34.6305 35.3744",
    stroke: "#A0A295",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M35.9121 27.1123L37.1327 32.3196",
    stroke: "#A0A295",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M26.9297 31.3242L27.6681 35.8392",
    stroke: "#A0A295",
    strokeMiterlimit: 10
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBobaAvatar4);
export default __webpack_public_path__ + "static/media/boba-avatar-4.a4b4217f.svg";
export { ForwardRef as ReactComponent };